<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">
            <div class="reduced-fit">
                <div class="main-content-header">
                    <h1>Relaciones de Entrega de Facturas</h1>
                </div>
                <LoadingContent v-if="isLoading" />
                <div class="row w-65">
                    <div class="col-lg-12 ">
                        <div class="card mb-30" >
                            <div class="card-content" >
                                <div class="card-body">
                                    <div class="card-header" >
                                        <h5 class="card-title">{{ titulo }}</h5>
                                    </div>
                                    <div class="row">
                                        <div class="col-10">
                                            <form>
                                                <div class="row">
                                                    <div class="col-4">
                                                        <div class="row ">
                                                            <label class="col-2 text-nowrap">Num ID</label>
                                                            <div class="col-3">
                                                                <input ref="numid" type="number" class="form-control form-control-sm" required disabled v-model="relacion.numid" />													
                                                            </div>
                                                        </div>	
                                                    </div>	
                                                    <div class="col-4 offset-4">
                                                        <div class="row ">
                                                            <label class="col-2 text-nowrap">Fecha Captura</label>
                                                            <div class="col-3">
                                                                <input ref="fechacaptura" type="date" class="form-control form-control-sm"   v-model="relacion.fechacaptura" />													
                                                            </div>
                                                        </div>	
                                                    </div>	
                                                </div>	
                                                <lookUpCtrl v-if="relacion.numid" :objeto="relacion" :label="'Cliente'" :cols="[1,2,9]" :archivo="'Clientes'" :campo="'clienteid'" :descripcion="'nombre'" v-model="relacion.cliente" />
                                                <div class="row">
                                                    <div class="col-4">
                                                        <div class="row ">
                                                            <label class="col-2 text-nowrap">Entrega</label>
                                                            <div class="col-3">
                                                                <input ref="fechaentrega" type="date" class="form-control form-control-sm"   v-model="relacion.fechaentrega" />													
                                                            </div>
                                                        </div>	
                                                    </div>	
                                                    <div class="col-4">
                                                        <div class="row ">
                                                            <label class="col-2 text-nowrap">Dias de Plazo</label>
                                                            <div class="col-3">
                                                                <input ref="plazo" type="number" class="form-control form-control-sm"   v-model="relacion.plazo" />													
                                                            </div>
                                                        </div>	
                                                    </div>	
                                                    <div class="col-4">
                                                        <div class="row ">
                                                            <label class="col-2 text-nowrap">Dia de Pago</label>
                                                            <div class="col-3">
                                                                <input ref="dpago" type="number" class="form-control form-control-sm"   v-model="relacion.dpago" />													
                                                            </div>
                                                        </div>	
                                                    </div>	
                                                </div>	
                                                <div class="row">
                                                    <div class="col-4">
                                                        <div class="row ">
                                                            <label class="col-2 text-nowrap">F. Pago</label>
                                                            <div class="col-3">
                                                                <input ref="fechapago" type="date" class="form-control form-control-sm"   v-model="relacion.fechapago" />													
                                                            </div>
                                                        </div>	
                                                    </div>	
                                                    <div class="col-4">
                                                        <div class="row ">
                                                            <label class="col-2 text-nowrap">Plazo F. Entrega</label>
                                                            <div class="col-3">
                                                                <input ref="plazoentrega" type="number" class="form-control form-control-sm" disabled  v-model="relacion.plazoentrega" />													
                                                            </div>
                                                        </div>	
                                                    </div>	
                                                    <div class="col-4">
                                                        <div class="row ">
                                                            <label class="col-2 text-nowrap">Folio HEB</label>
                                                            <div class="col-3">
                                                                <input ref="folio_heb" type="number" class="form-control form-control-sm"   v-model="relacion.folio_heb" />													
                                                            </div>
                                                        </div>	
                                                    </div>	
                                                </div>	   
                                            </form>
                                        </div>
                                        <div class="col-2">
                                            <ul class="d-block p-1 list-unstyled controls-form">
                                                <li><button @click="setRelacion()" class="btn btn-sm btn-success btn-block">Aceptar</button></li>
                                                <li><router-link to="/relacion" class="btn btn-sm btn-danger btn-block">Salir</router-link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import handleForm from '@/mixins/handleForm';
import LoadingContent from '@/components/LoadingSpinner.vue'
import handleGlobals from '@/mixins/handleGlobals'

import SideBar from '@/components/SideBarNav.vue';
import TopBar from '@/components/TopBarNav.vue';
export default {
    components:{SideBar, TopBar,LoadingContent },
    mixins:[handleForm,handleGlobals],
    data(){
        return{
            id: this.$route.params.relacion,
            modo: (this.$route.params.relacion > 0 ? 'Modificando' : 'Creacion'), 
            relacion: [],
            titulo: 'Agregando una Relación',
        }
    },
    mounted(){
        this.llenaForma();
    },
    methods:{
        async llenaForma(){
            await this.getRelacion();
            this.titulo = this.$route.params.relacion > 0 ? 'Cambiando una Relación' :  'Agregando una Relación'
        },
        getRelacion(){
            let req = []
            this.isLoading = true
             fetch(this.$api+'/rdx', {
                method: "POST",
                headers: { "Content-Type": "application/json",
                            'Authorization' : this.$store.state.iasctratkn },
                body: JSON.stringify({ accion: "inicializar", modo:this.modo, archivo: "Relacion", id: this.id })
            }).then((response)=>{
                if(response.ok){
                    return response.json()
                }   
            }).then((data)=>{
                this.relacion = data['res']
                req = data['req']
            }).finally(()=>{
                this.setRequired(req)
                this.isLoading = false
            }).catch((err)=>{
                this.falseToken(err)
            });
        },
        setRelacion(){
            fetch(this.$api+'/rdx', {
                method: "POST",
                headers: { "Content-Type": "application/json",
                            'Authorization' : this.$store.state.iasctratkn },
                body: JSON.stringify({  accion: 'validar', archivo: "Relacion", modo:this.modo, record: this.relacion }) 
            }).then((response)=>{
                if(response.ok){
                    return response.json();
                }   
            }).then((data)=>{
                if(data['res'] == 'error'){
                    this.showNotification = true
                    this.notificationTitle =  'Error'
                    this.notificationText = data['msg']
                    this.notificationRef = 'clave'
                }else{
                    this.$router.push('/relacion')
                }
            }).catch((err)=>{
                this.falseToken(err)
            });
        },
        afterClose(){
            this.$refs[this.notificationRef].focus()
        }
    }
}
</script>